module.exports = __webpack_public_path__ + "img/coffrepirate.1901e803.png";